/**
 * Common enum dropdown component connected to formik context
 */
import { useField } from 'formik';
import { DefaultItem } from '@adsk/alloy-react-dropdown';
import {
  PureEnumMultiDropdownField,
  PureEnumMultiDropdownFieldProps,
} from './PureEnumMultiDropdownField';

export type EnumMultiDropdownProps = Omit<Partial<PureEnumMultiDropdownFieldProps>, 'fieldName'> &
  Required<Pick<PureEnumMultiDropdownFieldProps, 'fieldName'>>;

export const EnumMultiDropdown = (props: EnumMultiDropdownProps) => {
  const { fieldName } = props;
  const [field, meta, helpers] = useField(fieldName);

  const error = meta.touched ? meta.error : undefined;

  const handleSelect = (value: DefaultItem[]) => {
    helpers.setValue(value.map((el) => el.value));
  };

  return <PureEnumMultiDropdownField {...props} {...field} error={error} onChange={handleSelect} />;
};
